/**
 * @module websocket.event.handlers.airports.airport-list-updated
 */
import { store } from '../../../../state/store'
import { setAirportListUpdated } from '../../../../state/websocket.slice'

export default function handleAirportListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setAirportListUpdated(data))
  }
} 